// Author XXL
// Date 2021-03-19 18:16:53

import * as model from "@/model/sithMes/inventory/SithMesInventoryStatusModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesInventoryStatus(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_INVENTORY_URL,
        selectRowsToItems: function (row) {
            return {value: row.code, text: row.name}
        },
    })
    .buildStore()
